import React from 'react';
import { Link } from 'react-router-dom';
import ResultItemDate from './helpers/ResultItemDate';
import IconForContentType from './helpers/IconForContentType';

// This is currently unused, due to the inability to use location
// and institute from SOLR.

const JobofferResultItem = ({ item }) => (
  <article className="tileItem itemWithTwoColumns">
    {/* <span className="contentTypeLabel">
      <FormattedMessage id={mapContentTypes(item['@type'])} />
    </span> */}
    <div className="itemContentTypeColumn">
      <IconForContentType type={item['@type']} />
    </div>
    <div className="itemMainColumn">
      <h2 className="tileHeadline">
        <Link to={item['@id']} className="summary url" title={item['@type']}>
          {item.title}
        </Link>
      </h2>
      <p className="url">{item['@id']}</p>
      {item?.highlighting && item.highlighting.length > 0 ? (
        <div className="tileBody">
          {(item?.effective || item?.extras?.start) && (
            <ResultItemDate
              date={item?.extras?.start ? item.extras.start : item?.effective}
              hasExcerpt={true}
            />
          )}
          <span
            className="description"
            dangerouslySetInnerHTML={{
              __html: item.highlighting,
            }}
          />
          {' ...'}
        </div>
      ) : (
        <>
          <div className="tileBody">
            {(item?.effective || item?.extras?.start) && (
              <ResultItemDate
                date={item?.extras?.start ? item.extras.start : item?.effective}
                hasExcerpt={item?.description}
              />
            )}
            <span className="description">
              {item.description
                ? item.description.length > 200
                  ? item.description.slice(0, 199) + '...'
                  : item.description
                : ''}
            </span>
          </div>
          <div className="tileBody search-job-offer-institute">
            {item?.extras?.job_offer_institute
              ? item.extras.job_offer_institute.length > 200
                ? item.extras.job_offer_institute.slice(0, 199) + '...'
                : item.extras.job_offer_institute
              : ''}
          </div>
          <div className="tileBody search-job-offer-location">
            {item?.extras?.job_offer_location
              ? item.extras.job_offer_location.length > 200
                ? item.extras.job_offer_location.slice(0, 199) + '...'
                : item.extras.job_offer_location
              : ''}
          </div>
        </>
      )}
    </div>
    <div className="visualClear" />
    {/* END CUSTOMIZATION */}
  </article>
);

export default JobofferResultItem;
